/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
*/
const original = require('../../../../packages/design-system/theme/src/colors.tsx');

module.exports = Object.assign({}, original, {
	red: original.R300,
	skeleton: () => 'N20A',
});

if (original.__esModule) Object.defineProperty(module.exports, '__esModule', { value: true });
